import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ActivityDetails from './activity-details';
import ActivityDetailsDetail from './activity-details-detail';
import ActivityDetailsUpdate from './activity-details-update';
import ActivityDetailsDeleteDialog from './activity-details-delete-dialog';

const ActivityDetailsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ActivityDetails />} />
    <Route path="new" element={<ActivityDetailsUpdate />} />
    <Route path=":id">
      <Route index element={<ActivityDetailsDetail />} />
      <Route path="edit" element={<ActivityDetailsUpdate />} />
      <Route path="delete" element={<ActivityDetailsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ActivityDetailsRoutes;
